import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function classificacaoReducer(state = initialState.classificacoes, action){
    switch(action.type) {
        case types.LISTAR_CLASSIFICACAO:
            
            return action.classificacoes;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/classificacaoReducer.js
 **/